import React from 'react';
import { isSigSyncNotary } from '../../../../../types/signingAppointment/ISigSyncNotaryDetailsData';
import { NoSigSyncNotaryAssigned } from './NoSigSyncNotaryAssigned';
import { NoNotaryAssigned } from './NoNotaryAssigned';
import { SigSyncNotaryDetails } from './SigSyncNotaryDetails';
import { NotaryDetails } from './NotaryDetails';
import { useSelectAppointmentFromPathParam } from '../../../../../utilities/order/scheduling/useSomeAppointmentFromParam';
import { determineCanEdit } from '../../EditAppointment/util';
import { eSigningMethod } from 'types/signingAppointment/eSigningMethod';
import { ISigningAppointmentResponse } from 'types/signingAppointment/ISigningAppointmentResponse';

export interface NotaryDetailsSectionProps {
  onUpdateNotaryClick: () => void;
}

export const NotaryDetailsSection: React.FC<NotaryDetailsSectionProps> = ({ onUpdateNotaryClick }) => {
  const { appointmentFromPath } = useSelectAppointmentFromPathParam();

  if (!appointmentFromPath) {
    return null;
  }

  if (shouldSkipNotaryDetails(appointmentFromPath)) {
    return null;
  }

  return renderNotaryDetails(appointmentFromPath, onUpdateNotaryClick);
};

export const shouldSkipNotaryDetails = (appointment: ISigningAppointmentResponse) => {
  const { signingMethod, notary, isDigitalScheduling, isDigitalSchedulingDraft } = appointment;
  return signingMethod === eSigningMethod.attorney && !notary && isDigitalScheduling && !isDigitalSchedulingDraft;
};

const renderNotaryDetails = (appointment: ISigningAppointmentResponse, onUpdateNotaryClick: () => void) => {
  const { notary, isSignatureSyncAppointment } = appointment;

  if (!notary) {
    return isSignatureSyncAppointment ? (
      <NoSigSyncNotaryAssigned />
    ) : (
      <NoNotaryAssigned onUpdateNotaryClick={onUpdateNotaryClick} />
    );
  }

  if (isSignatureSyncAppointment && isSigSyncNotary(notary)) {
    return <SigSyncNotaryDetails notary={notary} />;
  }

  return (
    <NotaryDetails notary={notary} onUpdateNotaryClick={onUpdateNotaryClick} canEdit={determineCanEdit(appointment)} />
  );
};
